// extracted by mini-css-extract-plugin
export default {"card":"style_card__cBuZQ","icon":"style_icon__bKkVH","title":"style_title__MT-sv","value":"style_value__wM-AW"};